import { WizardFormData, FormFields } from "./types";

export const WIZARD_FORM_FIELDS: FormFields<WizardFormData> = {
  custom: {
    fieldName: "custom",
    isDac: () => ({ fieldName: "custom.isDac" }),
    dacSession: {
      fieldName: "custom.dacSession",
      digitalAccountCheckTransactionId: () => ({ fieldName: "custom.dacSession.digitalAccountCheckTransactionId" }),
      wizardSessionKey: () => ({ fieldName: "custom.dacSession.wizardSessionKey" }),
    },
  },
  vehicleData: {
    fieldName: "vehicleData",
    vin: () => ({ fieldName: "vehicleData.vin" }),
    isUsed: () => ({ fieldName: "vehicleData.isUsed" }),
    recommendedRetailPriceAmount: {
      fieldName: "recommendedRetailPriceAmount",
      amount: () => ({ fieldName: "vehicleData.recommendedRetailPriceAmount.amount" }),
    },
    retailPriceAmount: {
      fieldName: "retailPriceAmount",
      amount: () => ({ fieldName: "vehicleData.retailPriceAmount.amount" }),
    },
    odometer: () => ({ fieldName: "vehicleData.odometer" }),
    initialRegistrationDate: () => ({ fieldName: "vehicleData.initialRegistrationDate" }),
    orderDate: () => ({ fieldName: "vehicleData.orderDate" }),
    deliveryData: {
      fieldName: "deliveryData",
      deliveryDate: () => ({ fieldName: "vehicleData.deliveryData.deliveryDate" }),
    },
    model: {
      fieldName: "model",
      manufacturer: () => ({ fieldName: "vehicleData.model.manufacturer" }),
      name: () => ({ fieldName: "vehicleData.model.name" }),
      descriptionLong: () => ({ fieldName: "vehicleData.model.descriptionLong" }),
      code: () => ({ fieldName: "vehicleData.model.code" }),
      year: () => ({ fieldName: "vehicleData.model.year" }),
      manufacturerCode: () => ({ fieldName: "vehicleData.model.manufacturerCode" }),
      typeCode: () => ({ fieldName: "vehicleData.model.typeCode" }),
    },
  },
};
